import styled from 'styled-components';
import { opacities } from '../../../defaultTheme';
export const AccordionWrapper = styled.div `
  border-radius: 15px;
  box-shadow: 0 1px 3px 0 ${opacities.rgbaLight10},
    0 2px 2px 0 ${opacities.rgbaLight08}, 0 0 2px 0 ${opacities.rgbaLight04};
  border: solid 1px ${({ theme }) => theme.accordion.borderColor};
  * {
    box-sizing: border-box;
  }
`;
export const AccordionHeaderWrapper = styled.div `
  cursor: pointer;
  border-radius: 15px;
  background-color: ${({ isAccordionBodyShown, transitionHasEnded, theme }) => {
    if (!isAccordionBodyShown && !transitionHasEnded) {
        return theme.accordion.headerBackgroundColor;
    }
    return theme.accordion.activeHeaderBackgroundColor;
}};
  transition: ${({ transitionDuration }) => `background-color ${transitionDuration}s ease-in-out;`};
  padding: 8px 20px;
  ${({ isAccordionBodyShown }) => isAccordionBodyShown &&
    `
      box-shadow: 0 2px 2px 0 ${opacities.rgbaLight08}, 0 0 2px 0 ${opacities.rgbaLight12};
    `}
  &:focus {
    overflow: hidden;
    outline: none;
    border: 1px solid ${({ theme }) => theme.field.focus};
  }
`;
export const AccordionBodyWrapper = styled.div `
  overflow: ${({ transitionHasEnded, isAccordionBodyShown }) => transitionHasEnded && isAccordionBodyShown ? 'visible' : 'hidden'};
  border-radius: 0px 0px 15px 15px;
  max-height: ${({ isAccordionBodyShown }) => isAccordionBodyShown ? `800px` : '0'};
  transition: ${({ transitionDuration }) => `max-height ${transitionDuration}s ease-in-out`};
`;
export const AccordionInnerBodyWrapper = styled.div `
  padding: 12px 20px;
`;
